function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Settings"));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-settings-clip-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.5 14c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5c1.421 0 2.675.675 3.5 1.706v-6.707h-27v6.707c.825-1.032 2.079-1.707 3.5-1.707 2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5c-1.421 0-2.675-.675-3.5-1.706v19.706h27v-19.706c-.825 1.032-2.079 1.706-3.5 1.706zm-10 14c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 27,
  "data-height": 32,
  transform: "translate(2)"
}, /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#iconic-size-md-settings-clip-0)",
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "round",
  className: "iconic-settings-line iconic-settings-line-1 iconic-property-accent iconic-property-stroke",
  fill: "none",
  d: "M3.5 1.5v29"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#iconic-size-md-settings-clip-0)",
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "round",
  className: "iconic-settings-line iconic-settings-line-2 iconic-property-accent iconic-property-stroke",
  fill: "none",
  d: "M13.5 1.5v29"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#iconic-size-md-settings-clip-0)",
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "round",
  className: "iconic-settings-line iconic-settings-line-3 iconic-property-accent iconic-property-stroke",
  fill: "none",
  d: "M23.5 1.5v29"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 6c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z",
  className: "iconic-settings-knob iconic-settings-knob-3 iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 20c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z",
  className: "iconic-settings-knob iconic-settings-knob-2 iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 6c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z",
  className: "iconic-settings-knob iconic-settings-knob-1 iconic-property-fill"
}));

function SvgSettingsMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "settings",
    className: "iconic iconic-settings iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMd);
export default __webpack_public_path__ + "static/media/settings-md.38e0f2a2.svg";
export { ForwardRef as ReactComponent };